import jwt from 'jsonwebtoken';

import dateConversion from '../../../../../utils/dateConversion';
import service from '../../../../../services';
import { decryptData } from '../../../../../services/decryptData';

export default {
  prepare(item) {
    item.idProposta = item.id_proposta;
    item.dadosVeiculo = { ...item.Eventos_Veiculo };
    item.dadosVeiculo.codTipoVeiculo =
      item.Eventos_Veiculo.Grupo_Veiculo.idTipoFipe;
    item.tipoEvento = { ...item.Eventos_TipoEvento };
    if (item.Eventos_TipoColisao)
      item.idTipoColisao = item.Eventos_TipoColisao.idTipoColisao;
    item.tipoColisao = { ...item.Eventos_TipoColisao };
    item.idStatus = item.Eventos_Status.idStatus;
    item.nomeStatus = item.Eventos_Status.nomeStatus;
    item.dataHoraContatoAssistencia = item.dataHoraContatoAssistencia
      ? dateConversion.convertISOToDateHour(item.dataHoraContatoAssistencia)
      : null;
    item.dadosCliente = {
      ...item.Eventos_Associado,
      dataNascimento: dateConversion.converteISOToDate(item.dataNascimento),
      dataVencimentoCnh: dateConversion.converteISOToDate(
        item.dataVencimentoCnh,
      ),
    };
    item.enderecoEvento = JSON.parse(item.enderecoEvento);
    item.dadosCondutor = JSON.parse(item.dadosCondutor);
    item.dadosAssociado = { ...item.Eventos_Associado };

    return item;
  },

  /**
   * Recupera List domínio
   * @param {string} model nome do model
   * @param {string} fieldLabel nome do campo de descrição
   * @param {string} filedId nome do campo PK
   */
  async getListDominio(model, fieldLabel, filedId) {
    try {
      const result = [];
      let getAll = await service.getAll('g', {}, `${model}/list/`);
      getAll.data = decryptData(getAll.data);
      getAll.data.forEach((element) => {
        result.push({
          id: element[filedId],
          label: element[fieldLabel],
        });
      });

      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * Recupera listagem dos Usuários
   */
  async getListUsuarios() {
    try {
      const result = [];
      const res = await service.getAll(
        'Usuario',
        {},
        `list-usuario-por-setor?setor=eventos`,
      );

      res.data.forEach((element) => {
        result.push({
          id: element.idUsuario,
          label: element.nome,
        });
      });
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * Recupera Lista de Vistoriadores por empresa
   * O idEmpresa vai como nulo, e o método busca o idEmpresa do token do usuário
   */
  async getListVistoriadores() {
    try {
      const result = [];
      const res = await service.getAll(
        'Vistoriador',
        {},
        'list/idEmpresa=' + null,
      );

      res.data.forEach((element) => {
        result.push({
          id: element.idVistoriador,
          label: element.nome,
        });
      });
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * Recupera Lista de Oficinas/Fornecedores
   */
  async getListOficinas() {
    try {
      const res = await service.getAll(
        'fornecedor',
        {},
        'buscar-fornecedores/',
      );

      const result = res.data.map((o) => {
        return {
          ...o,
          labelCompleta: `${o.razaoSocial} - ${o.nomeFantasia} - ${o.cpf_cnpj}`,
        };
      });

      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getListWorkshops(search = '', page = 1, limit = 10) {
    try {
      const params = new URLSearchParams({
        page,
        limit,
        fantasyName: search,
      }).toString();

      const res = await service.getAll(
        'fornecedor',
        null,
        `buscar-oficinas/?${params}`,
      );
      return Promise.resolve(res.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async getWorkshopById(workshopId) {
    try {
      const res = await service.getAll(
        'fornecedor',
        null,
        `buscar-oficina/${workshopId}`,
      );
      return Promise.resolve(res.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * Recupera Lista de Marcas por tipo de veículo
   * @param {number} idTipo id do tipo Fipe do veículo
   */
  async getListMarcasPorTipo(idTipo) {
    try {
      const res = await service.post(
        'Fipe',
        'consultar-marcas-por-tipo-veiculo',
        { tipoVeiculo: idTipo },
      );
      const result = [];
      res.data.forEach((element) => {
        result.push({
          id: parseInt(element.value.id),
          label: element.value.valor,
        });
      });
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * Recupera Lista de Modelos e de Anos Modelo por marca, retornando dois arrays de objetos, respectivamente
   * @param {number} idTipo id do tipo Fipe do veículo
   * @param {string} idMarca id da Marca
   */
  async getListModelosAndAnosModeloPorMarca(obj) {
    try {
      const objSend = {
        codigoTipoVeiculo: obj.idTipoVeiculo,
        codigoMarca: obj.idMarca,
      };
      const resultModelos = [];
      const resultAnosModelo = [];

      const res = await service.post('Fipe', 'ConsultarModelos', objSend);

      // Monta array de Modelos
      res.data[0].forEach((element) => {
        resultModelos.push({
          id: element.id,
          label: element.name,
        });
      });

      // Monta array de Anos Modelo
      res.data[1].forEach((element) => {
        if (element.name.includes('32000')) {
          resultAnosModelo.push({
            id: element.id,
            label: '0km',
          });
        } else {
          resultAnosModelo.push({
            id: element.id,
            label: element.name,
          });
        }
      });
      return {
        listModelos: resultModelos,
        listAnosModelo: resultAnosModelo,
      };
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * Recupera Lista de Modelos por Ano Modelo
   * @param {number} idAnoModelo ano do modelo
   */
  async getListModelosPorAnoModelo(obj) {
    const objSend = {
      codigoTipoVeiculo: obj.idTipoVeiculo,
      codigoMarca: obj.idMarca,
      ano: obj.ano,
    };
    try {
      const result = [];
      const res = await service.post('Fipe', 'ConsultarModelosPorAno', objSend);

      res.data.forEach((element) => {
        result.push({
          id: parseInt(element.id),
          label: element.name,
        });
      });
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   *
   * Gera List Combustivel
   * @param {array} arrayAnosModelo array de Anos Modelo, seguindo o retorno da API da Fipe, no seguinte modelo
   * const arrayAnosModelo = [
      {id: '1995-1', label: '1995 Gasolina'},
      {id: '1995-2', label: '1995 Alcool'},
      {id: '1995-3', label: '1995 Diesel'},
      {id: '1995-4', label: '1995 Gasolina'}
      ];
   * @param {number} idTipoVeiculo id do tipo Fipe do veículo
   */
  getListCombustiveis(arrayAnosModelo, idTipoVeiculo) {
    const listCombustivel = [];

    arrayAnosModelo.forEach((element) => {
      const label = element.label.toLowerCase();

      // Adiciona o valor 'Gasolina' caso encontrado e ainda não exista no array
      if (label.includes('gasolina')) {
        if (!listCombustivel.includes('Gasolina')) {
          listCombustivel.push('Gasolina');
        }

        // Adiciona o valor 'Alcool' caso encontrado e ainda não exista no array
      } else if (label.includes('alcool')) {
        if (!listCombustivel.includes('Alcool')) {
          listCombustivel.push('Alcool');
        }

        // Adiciona o valor 'Diesel' caso encontrado e ainda não exista no array
      } else if (label.includes('diesel')) {
        if (!listCombustivel.includes('Diesel')) {
          listCombustivel.push('Diesel');
        }

        // Adiciona o valor 'Gasolina' caso o veículo seja uma moto e ainda não exista no array, pois a API é omissa ao combustível quando moto
      } else if (idTipoVeiculo == 2) {
        if (!listCombustivel.includes('Gasolina')) {
          listCombustivel.push('Gasolina');
        }

        // Adiciona o valor 'Diesel' caso o veículo seja um caminhão e ainda não exista no array, pois a API é omissa ao combustível quando caminhão
      } else if (idTipoVeiculo == 3) {
        if (!listCombustivel.includes('Diesel')) {
          listCombustivel.push('Diesel');
        }
      }
    });

    return listCombustivel;
  },

  /** Gera List Anos Fabricacao
   * @param {string} anoModelo ano do modelo com ou sem código de combustível
   * Exemplo: "32000-3", "1997-1", "2018-2"
   */
  getListAnosFabricacao(anoModelo) {
    const listAnosFabricacao = [];
    if (anoModelo.includes('32000')) {
      listAnosFabricacao.push('0km');
      return listAnosFabricacao;
    }

    const capturaAno = Number(anoModelo.substring(0, 4));

    listAnosFabricacao.push(capturaAno, capturaAno - 1);
    return listAnosFabricacao;
  },

  /**
   * Recupera Lista de Cores e Combustível
   */
  async getListCoresAndCombustiveis() {
    try {
      const res = await service.post('Cotacao', 'listarCoresECombustivel', {
        idEmpresa: null,
      });

      // Monta combustíveis
      const listCombustiveis = [];
      res.data.combustiveis.forEach((element) => {
        listCombustiveis.push({
          id: element.idCombustivel,
          label: element.descricao,
        });
      });

      // Monta cores
      const listCores = [];
      res.data.cores.forEach((element) => {
        listCores.push({
          id: element.idCor,
          label: element.descricao,
        });
      });

      const result = {
        listCombustiveis,
        listCores,
      };
      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * Busca valor e código FIPE
   * @param {object} obj no seguinte contrato:
   *{ ano: "2004-1"
   * anoModelo: "2004"
   * codigoMarca: "61"
   * codigoModelo: "2597"
   * codigoTipoCombustivel: "1"
   * codigoTipoVeiculo: 2}
   * @return {Promise<object>}
   */
  async getValorFipe(obj) {
    try {
      const result = await service.post(
        'Fipe',
        'ConsultarValorComTodosParametros',
        obj,
      );

      return Promise.resolve(result);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async buscaVeiculoPorCodigoFipe(codigoFipe) {
    try {
      const objSend = {
        codigoFipe: codigoFipe,
      };

      const result = await service.post(
        'Fipe',
        'ConsultarValorSoComFipe',
        objSend,
      );
      return Promise.resolve(result.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * Busca lista de tipos de localização de documentos
   * @return {Promise<array<object>>}
   */
  async getListLocalizacaoDocumentacao() {
    try {
      const listLocalizacaoDocumentacao = [];
      const result = await service.getAll(
        'Eventos',
        {},
        'buscar-localizacao-documentos',
      );

      result.data.forEach((element) => {
        listLocalizacaoDocumentacao.push({
          id: element.idLocalizacaoDocumento,
          label: element.descricao,
        });
      });

      return Promise.resolve(listLocalizacaoDocumentacao);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * Cria novo terceiro
   * @param {Number} idEvento id do Evento
   * @param {String} tipo Tipo do Terceiro (T=Terceiro/P=Patrimônio)
   * @return {Promise<object>}
   */
  async postTerceiro(idEvento, tipo = 'T', idUsuarioRealizouAbertura) {
    try {
      const objSend = { idEvento, tipo, idUsuarioRealizouAbertura };
      const result = await service.post('eventos-terceiros', 'create', objSend);
      return Promise.resolve(result.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  /**
   * Inativa terceiros
   * @param {number} idEnvolvido que será inativado
   * @return
   */
  async softDeleteTerceiro(idEnvolvido) {
    try {
      const objSend = { idEnvolvido };
      const result = await service.post('eventos-terceiros', 'delete', objSend);
      return Promise.resolve(result.data);
    } catch (error) {
      return Promise.reject(error);
    }
  },

  getIdUsuario() {
    const token = localStorage.getItem('user-token');
    if (token) {
      const decoded = jwt.decode(token);
      return decoded.id_usuario || null;
    }

    return null;
  },

  async getListTipoArquivoEvento(idEmpresa) {
    try {
      const resultTipoArquivoEvento = await service.getAll(
        'eventos2',
        {},
        `tipos-arquivos/${idEmpresa}`,
      );
      return resultTipoArquivoEvento;
    } catch (error) {
      throw new Error(error);
    }
  },

  async getEventosPorBeneficiario(idBeneficiario, pagina) {
    try {
      if (!idBeneficiario) {
        throw new Error('Id do Beneficiário deve ser informado');
      }

      const listEventosPorBeneficiario = await service.getAll(
        'eventos2',
        {},
        `busca-eventos/${idBeneficiario}?pagina=${pagina}`,
      );

      return listEventosPorBeneficiario;
    } catch (error) {
      throw new Error(error);
    }
  },

  async getQtdTiposEventosPorBeneficiario(idBeneficiario) {
    try {
      if (!idBeneficiario) {
        throw new Error('Id do Beneficiário deve ser informado');
      }

      const listQtdTiposEventosPorBeneficiario = await service.getAll(
        'eventos2',
        {},
        `busca-quantidade-tipo-eventos/${idBeneficiario}`,
      );
      return listQtdTiposEventosPorBeneficiario;
    } catch (error) {
      throw new Error(error);
    }
  },

  async postCreatePartsRegister(idEvent, partsRegister) {
    try {
      const result = await service.post(
        'eventos2',
        `create-parts-register/${idEvent}`,
        partsRegister,
      );
      return result.data;
    } catch (error) {
      throw new Error(error);
    }
  },

  async getPartsRegisterAll(eventId, typeRegister) {
    try {
      const result = await service.getAll(
        'eventos2',
        {},
        `get-parts-register-list/${eventId}/${typeRegister}`,
      );
      return result.data;
    } catch (error) {
      throw new Error(error);
    }
  },

  async updatePartsRegister(partPurchaseId, payload) {
    try {
      const result = await service.put(
        'eventos2',
        `update-parts-register/${partPurchaseId}`,
        payload,
        {},
      );
      return result.data;
    } catch (error) {
      throw new Error(error);
    }
  },

  async deletePartsRegister(partPurchaseId) {
    try {
      await service.delete(
        'eventos2',
        `delete-parts-register/${partPurchaseId}`,
        {},
        {},
      );
    } catch (error) {
      throw new Error(error);
    }
  },
};
